import './utils/ignoreResizeObserverError';
import React from 'react';
import ReactDOM from 'react-dom';
import './axios.config';
import 'element-theme-default';
import 'antd/dist/antd.min.css';
import Cookies from 'js-cookie';
import './index.scss';
import 'intro.js/introjs.css';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import { ConfigProvider } from 'antd';
import App from './App';
import { LangCode } from '@/config/const';
import 'moment/locale/zh-cn';

// eslint-disable-next-line no-console
console.info('[frontend-lvbit-web] build config', {
  env: process.env.REACT_APP_ENV || process.env.NODE_ENV,
  api: process.env.REACT_APP_API_PROXY_SERVER,
});

const lang = (localStorage.getItem('lang') || Cookies.get('lang') || 'zh') as LangCode;
const locale = lang === 'en' ? enUS : zhCN;
// moment.locale(lang);
ReactDOM.render(
  <ConfigProvider locale={locale}>
    <App />
  </ConfigProvider>,
  document.getElementById('root'),
);
